import { listLabels, getLabel, deleteLabel, createLabel, updateLabel, queryLabels, countLabels, bulkDeleteLabels } from '@wix/ambassador-restaurants-menus-v1-item-label/http';
import { ErrorTypes } from '../types/api';
import { BaseAPIClient } from './BaseAPIClient';
import { BULK_DELETE_CHUNK_SIZE, callInChunks } from './utils';
export class LabelsClient extends BaseAPIClient {
  async getById(labelId) {
    const response = await this.request(getLabel, {
      labelId
    });
    return response.data.label;
  }
  async getBulk() {
    const response = await this.request(listLabels, {});
    return {
      data: response.data.labels
    };
  }
  async create(label) {
    const response = await this.request(createLabel, {
      label
    });
    return response.data.label;
  }
  async update(label) {
    const response = await this.request(updateLabel, {
      label
    });
    return response.data.label;
  }
  async delete(labelId) {
    const response = await this.request(deleteLabel, {
      labelId
    });
    return response.data;
  }
  async query(query) {
    const response = await this.request(queryLabels, {
      query
    });
    return {
      data: response.data.labels,
      pagingMetadata: response.data.pagingMetadata
    };
  }
  async countLabels(filter) {
    const response = await this.request(countLabels, {
      filter
    });
    return response.data.count;
  }
  async bulkDelete(labelIds) {
    var _response$bulkActionM;
    const response = await callInChunks(chunkLabelIds => this.request(bulkDeleteLabels, {
      ids: chunkLabelIds
    }), labelIds, BULK_DELETE_CHUNK_SIZE);
    if ((_response$bulkActionM = response.bulkActionMetadata) != null && _response$bulkActionM.totalFailures) {
      var _response$results;
      const errors = ((_response$results = response.results) == null ? void 0 : _response$results.filter(result => {
        var _result$itemMetadata;
        return (_result$itemMetadata = result.itemMetadata) == null ? void 0 : _result$itemMetadata.error;
      })) || [];
      const errorMessage = {
        name: ErrorTypes.BULK_DELETE_LABELS,
        message: errors.map(result => {
          var _result$itemMetadata2;
          return (_result$itemMetadata2 = result.itemMetadata) == null ? void 0 : _result$itemMetadata2.error;
        }).join(', ')
      };
      throw new Error('Failed to delete labels', {
        cause: errorMessage
      });
    }
    return {};
  }
}
//# sourceMappingURL=LabelsClient.js.map